<div class="spacerWrapper" fxLayout="column">
    <h1 mat-dialog-title class="dialogTitle">{{ title }}</h1>
    <h3 class="dialogSubTitle">{{ eventName }}</h3>

    <div mat-dialog-content>
        <form [formGroup]="eventDetailEditorForm" class="grid-container">
            <div class="inputContainer subtitle">
                <label>Subtitle: 
                </label>
                <mat-form-field appearance="outline">
                    <input matInput #subtitleInput type="text" maxlength="200" formControlName="subtitle"/>
                    <button *ngIf="subtitleInput.value" matSuffix mat-icon-button aria-label="Clear" (click)="subtitleInput.value=''; subtitle.setValue(''); subtitleActive.setValue(false);">
                        <mat-icon>close</mat-icon>
                    </button>
                    <!-- <mat-hint align="end">{{subtitleInput.value?.length || 0}}/200</mat-hint> -->
                </mat-form-field>
            </div>

            <div class="inputContainer subtitleActive">
                <mat-checkbox formControlName="subtitleActive" aria-label="Cancelled"> Active Subtitle </mat-checkbox>
                <mat-icon matTooltip="When active, the subtitle will append to the end of any Master Event title. Otherwise, the subtitle will not be displayed." class="helpIcon">help</mat-icon>
            </div>

            <div class="inputContainer startDate">
                <label>Start Date</label>
                <mat-form-field appearance="outline">
                    <input matInput type="datetime-local" formControlName="startDate" />
                </mat-form-field>
            </div>

            <div class="inputContainer endDate">
                <label>Ending Date</label>
                <mat-form-field appearance="outline" [class.mat-form-field-invalid]="eventDetailEditorForm.hasError('endDateInvalid')">
                    <input matInput type="datetime-local" formControlName="endDate" />
                </mat-form-field>
            </div>

            <!-- <div class="inputContainer startDate">
                <label>Start Date: </label>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="startDate" [matDatepicker]="startDatePicker" placeholder="MM/DD/YYYY" />
                    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="inputContainer endDate">
                <label>Ending Date: </label>
                <mat-form-field appearance="outline" [class.mat-form-field-invalid]="eventDetailEditorForm.hasError('endDateInvalid')">
                    <input matInput formControlName="endDate" [matDatepicker]="endDatePicker" placeholder="MM/DD/YYYY" />
                    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #endDatePicker></mat-datepicker>
                </mat-form-field>
            </div> -->

            <!-- <div class="inputContainer startTime">
                <label>Start Time: </label>
                <mat-form-field appearance="outline">
                    <input matInput type="time" formControlName="startTime" />
                </mat-form-field>
            </div>
            <div class="inputContainer endTime">
                <label>Ending Time: </label>
                <mat-form-field appearance="outline" [class.mat-form-field-invalid]="eventDetailEditorForm.hasError('endTimeInvalid')">
                    <input matInput type="time" formControlName="endTime" />
                </mat-form-field>
            </div> -->

            <div class="inputContainer checkboxes">
                <ul style="list-style-type: none; margin-top: 4px">
                    <li>
                        <mat-checkbox formControlName="cancelled" aria-label="Cancelled"> Cancelled </mat-checkbox>
                    </li>
                    <li>
                        <mat-checkbox formControlName="tentative" aria-label="Tentative"> Tentative </mat-checkbox>
                    </li>
                    <li>
                        <mat-checkbox formControlName="allDay" (change)="onToggleAllDay($event)" aria-label="All Day Event">
                            All Day Event
                        </mat-checkbox>
                    </li>
                </ul>
            </div>

            <div class="inputContainer location">
                <label>Location: </label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="location" />
                </mat-form-field>
            </div>
        </form>
    </div>

    <div class="spacer" fxFlex></div>
    <div class="actions">
        <div class="error-messages" fxLayout="column" fxLayoutAlign="start end">
            <mat-error *ngIf="startDate.invalid && startDate.touched">
                <mat-icon aria-hidden="false" aria-label="Error: Missing Start Date">error</mat-icon>
                Missing Start Date.
            </mat-error>

            <mat-error *ngIf="endDate.invalid && endDate.touched">
                <mat-icon aria-hidden="false" aria-label="Error: Missing End Date">error</mat-icon>
                Missing End Date.
            </mat-error>

            <!-- <mat-error *ngIf="startTime.invalid && startTime.touched">
                <mat-icon aria-hidden="false" aria-label="Error: Missing Start Time">error</mat-icon>
                Missing Start Time.
            </mat-error>

            <mat-error *ngIf="endTime.invalid && endTime.touched">
                <mat-icon aria-hidden="false" aria-label="Error: Missing End Time">error</mat-icon>
                Missing Ending Time.
            </mat-error> -->

            <mat-error *ngIf="eventDetailEditorForm.errors?.endDateInvalid">
                <mat-icon aria-hidden="false" aria-label="Error: Ending Date cannot occurr before Start Date">error </mat-icon>
                Ending Date cannot occurr before Start Date.
            </mat-error>

            <!-- <mat-error *ngIf="eventDetailEditorForm.errors?.endTimeInvalid">
                <mat-icon aria-hidden="false" aria-label="Error: Ending Time cannot occurr before Start Time">error</mat-icon>
                Ending Time cannot occurr before Start Time.
            </mat-error> -->
        </div>

        <div mat-dialog-actions align="end">
            <button mat-raised-button type="submit" color="primary" (click)="onSubmit(eventDetailEditorForm.value)">Save</button>
            <button mat-raised-button type="button" (click)="onNoClick()">Cancel</button>
        </div>
    </div>
</div>
